import { Component } from '@angular/core';

@Component({
  selector: 'vx-flow-page',
  standalone: true,
  template: `
    <section class="flow-page">
      <div class="container">
        <header class="flow-hero reveal">
          <span class="eyebrow">Come funziona</span>
          <h1>Come funziona VaulTriX</h1>
          <p>Un flusso semplice per utenti e operatori, con sicurezza by design.</p>
        </header>

        <div class="journey">
          @for (step of steps; track step.title; let i = $index) {
            <article class="journey-step reveal">
              <span>{{ i + 1 }}</span>
              <div>
                <h2>{{ step.title }}</h2>
                <p>{{ step.text }}</p>
              </div>
            </article>
          }
        </div>

        <section class="security-panel">
          <div>
            <span class="eyebrow">Sicurezza</span>
            <h2>Vantaggi di sicurezza</h2>
          </div>
          <ul>
            @for (item of security; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        </section>

        <!--<section class="choice-panel">
          <h2>Perché scegliere VaulTriX</h2>
        </section>-->
      </div>
    </section>
  `,
  styles: [`
    .flow-page {
      min-height: calc(100vh - 78px);
      padding: 84px 0 96px;
      color: #21094f;
      background:
        radial-gradient(circle at 14% 18%, rgba(84,216,232,.14), transparent 22rem),
        linear-gradient(135deg, #f7f2ff, #eef8ff);
    }
    .flow-hero {
      max-width: 820px;
      margin-bottom: 34px;
    }
    h1 {
      margin: 10px 0 14px;
      font-family: "Space Grotesk", sans-serif;
      font-size: clamp(2.4rem, 6vw, 5rem);
      line-height: 0.95;
      letter-spacing: -0.06em;
    }
    .flow-hero p {
      margin: 0;
      color: #3d266b;
      font-size: 1.18rem;
      font-weight: 850;
    }
    .journey {
      position: relative;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 18px;
      margin-bottom: 26px;
    }
    .journey-step {
      min-height: 330px;
      display: grid;
      align-content: start;
      gap: 28px;
      padding: 24px;
      border-radius: 28px;
      background:
        linear-gradient(145deg, rgba(255,255,255,.9), rgba(255,255,255,.62)),
        radial-gradient(circle at 80% 0%, rgba(84,216,232,.18), transparent 12rem);
      border: 1px solid rgba(64,40,106,.12);
      box-shadow: var(--vx-shadow);
    }
    .journey-step:nth-child(even) {
      transform: translateY(28px);
    }
    .journey-step span {
      width: 56px;
      height: 56px;
      display: grid;
      place-items: center;
      border-radius: 18px;
      color: white;
      background: linear-gradient(135deg, #241044, #673ab7);
      font-family: "Space Grotesk", sans-serif;
      font-size: 1.35rem;
      font-weight: 900;
    }
    h2 {
      margin: 0 0 12px;
      font-family: "Space Grotesk", sans-serif;
      font-size: 1.28rem;
      line-height: 1.05;
    }
    .journey-step p {
      margin: 0;
      color: #3d266b;
      font-size: 1rem;
      font-weight: 750;
      line-height: 1.55;
    }
    .security-panel {
      display: grid;
      grid-template-columns: 0.8fr 1.2fr;
      gap: 28px;
      margin-top: 70px;
      padding: 30px;
      border-radius: 30px;
      color: white;
      background:
        radial-gradient(circle at 88% 12%, rgba(84,216,232,.22), transparent 18rem),
        linear-gradient(145deg, #241044, #40286a);
      box-shadow: var(--vx-shadow);
    }
    .security-panel .eyebrow { color: #54d8e8; }
    .security-panel h2 {
      font-size: clamp(1.8rem, 4vw, 3rem);
    }
    .security-panel ul {
      display: grid;
      gap: 14px;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .security-panel li {
      position: relative;
      padding-left: 24px;
      color: rgba(255,255,255,.84);
      font-weight: 800;
      line-height: 1.45;
    }
    .security-panel li::before {
      content: "";
      position: absolute;
      left: 0;
      top: .58em;
      width: 9px;
      height: 9px;
      border-radius: 999px;
      background: #54d8e8;
    }
    .choice-panel {
      margin-top: 24px;
      padding: 24px;
      border-radius: 26px;
      background: #c7b2ec;
      border: 1px solid rgba(64,40,106,.22);
      text-align: center;
    }
    .choice-panel h2 {
      margin: 0;
    }
    @media (max-width: 1050px) {
      .journey { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      .journey-step:nth-child(even) { transform: none; }
      .security-panel { grid-template-columns: 1fr; }
    }
    @media (max-width: 640px) {
      .journey { grid-template-columns: 1fr; }
      .journey-step { min-height: auto; }
    }
  `]
})
export class FlowPageComponent {
  protected readonly steps = [
    {
      title: 'Scelta del locker',
      text: 'L’utente individua il punto VaulTriX più vicino tramite mappa o segnaletica in città e seleziona il locker disponibile tramite app o totem.'
    },
    {
      title: 'Prenotazione e pagamento',
      text: 'In pochi passaggi l’utente sceglie la durata del deposito, conferma il pagamento digitale e riceve un QR code o PIN univoco per l’accesso.'
    },
    {
      title: 'Deposito del bagaglio',
      text: 'L’utente scansiona il QR code o inserisce il PIN sul locker, lo sportello si apre automaticamente e il bagaglio viene depositato in sicurezza.'
    },
    {
      title: 'Ritiro 24/7',
      text: 'Alla fine del periodo, l’utente torna al locker, utilizza nuovamente il codice di accesso e ritira il bagaglio in autonomia.'
    }
  ];

  protected readonly security = [
    'Accessi tracciati digitalmente con log di apertura/chiusura.',
    'Locker robusti, videosorvegliati e integrabili con sistemi di sicurezza esistenti.',
    'Nessuna gestione di chiavi fisiche: tutto passa da codici temporanei.',
    'Pannello di controllo per monitorare anomalie, allarmi e manutenzione preventiva.'
  ];
}
